/* @flow */
/* eslint-disable max-statements */
import produce from 'immer'

export default function reducer(state, action: any) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
      case 'REMOVE_BACKGROUND_IMAGE':
        draft.backgroundImgUrl = ''
        draft.backgroundImgDimensions = {}
        break
      case 'CHANGE_BACKGROUND_IMAGE':
        const { url, dimensions } = action.value
        draft.backgroundImgUrl = url
        draft.backgroundImgDimensions = dimensions
        break
      case 'CHANGE_BG_OVERLAY_TRANSPARENCY':
        draft.bgOverlayTransparency = action.value
        break
      case 'CHANGE_CLIENT_URL':
        {
          const { idx, link } = action.value
          draft.slides[idx].clientUrl = link
        }
        break
      case 'ADD_SLIDE': {
        const activeIdx = action.value
        draft.slides = [
          ...draft.slides.slice(0, activeIdx + 1),
          initialState.slides[0],
          ...draft.slides.slice(activeIdx + 1)
        ]
        break
      }
      case 'REMOVE_CLIENT_LOGO':
        draft.slides.splice(action.value.idx, 1)
        break
      case 'CHANGE_CLIENT_LOGO': {
        const { idx, url, imgDimensions } = action.value
        draft.slides[idx].imageUrl = url
        draft.slides[idx].imgDimensions = imgDimensions || {}
        break
      }
      case 'SET_IMG_CROP_PARAMS': {
        const { imgCropParams, idx } = action.value
        draft.slides[idx].imgCropParams = imgCropParams
        break
      }
    }
  })
}
